import React, { Component, Fragment } from 'react';
import { Table, Jumbotron, Row, Col, Button, Form } from 'react-bootstrap';
import Menu from '../menu';
import config from '../../config';
import { CSVLink } from "react-csv";

export class ReporteConsolidadoEmp extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            info: [],
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            empresa: currentCompany
        }
    }

    updateReport = () => {
        const { fecha_inicial, fecha_final, empresa } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                fecha_inicial,
                fecha_final,
                empresa
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }

        fetch(config.servBackEnd + '/reports/employeeconsolidated', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    console.log(data)
                    const info = data.data[0];
                    console.log(info)
                    this.setState({ info })
                } else {
                    this.setState({ info: [] })
                }
            })
            .catch((error) => console.error(error))
    }

    render() {
        const { info } = this.state;
        return (
            <Fragment>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">Reporte Consolidado por Empleado</Jumbotron>
                <Row>
                    <Col>
                        Fecha Inicial <Form.Control type="date" onChange={(e) => this.setState({ fecha_inicial: e.target.value })} value={this.state.fecha_inicial} />
                    </Col>
                    <Col>
                        Fecha Final <Form.Control type="date" onChange={(e) => this.setState({ fecha_final: e.target.value })} value={this.state.fecha_final} />
                    </Col>
                    <Col>
                        <Button variant="primary" className="m-3" onClick={this.updateReport} >Genera Informe</Button>
                    </Col>
                    <Col>
                        <CSVLink data={info} filename={"REPORTE_DETALALDO.csv"} separator={";"}>
                            <Button disabled={info.length === 0} variant="success">Descargar Reporte</Button>
                        </CSVLink>
                    </Col>
                </Row>
                <Table className="tableFixHead">
                    <thead>
                        <tr>
                            <th>NIT EMPLEADO</th>
                            <th>NOMBRE EMPLEADO</th>
                            <th>DEVENGADO</th>
                            <th>DEDUCIDO</th>
                            <th>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            info.map((element, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{element.DOCUMENTO_CLIENTE}</td>
                                        <td>{element.NOMBRE_CLIENTE}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.DEVENGADO_TOTAL)}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.DEDUCCIONES_TOTAL)}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.COMPROBANTE_TOTAL)}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>
            </Fragment>
        )
    }
}

export default ReporteConsolidadoEmp
